import { environment } from '../../../../environments/environment';

export function UserEmailAvailableValidatorDirective($q, $http) {
  return {
    require: 'ngModel',
    link: function (scope, element, attrs, ngModel) {
      ngModel.$asyncValidators.userEmailAvailable = function (modelValue) {
        if (modelValue !== attrs.userEmailAvailableValidator) {
          var params = {
            // Send apart in order to work special characters
            q: modelValue,
          };

          return $http.get(environment.apiEndpoint + 'sessions/check_user_email', {
            params: params,
          });
        }

        return $q.resolve(true);
      };
    },
  };
}

UserEmailAvailableValidatorDirective.$inject = ['$q', '$http'];
